import { Trans } from '@lingui/macro';
import React, { FC } from 'react';

import { TLatestRequest } from 'Components/LatestRequests/LatestRequests.helpers';
import Modal from 'common/Modal/Modal';
import { Button } from 'uikit/Button';
import { TextDisplay, TextP3, TextP1 } from 'uikit/Text';
import analytics from 'utils/analytics/analytics';

import benefits4 from './icons/benefits4.png';
import benefits5 from './icons/benefits5.png';
import benefits6 from './icons/benefits6.png';
import benefits8 from './icons/benefits8.png';
import './RequestModal.scss';

type Props = {
  handleClose: () => void;
  data: TLatestRequest | null;
};

export const RequestModal: FC<Props> = (props) => {
  if (!props.data) return null;

  const city = props.data.city;
  const onButtonClicked = () => {
    analytics.trackEvent('sp_registration_scroll_to_reg', { rel_entity_id: 'request_details' });
    props.handleClose();
  };

  return (
    <Modal isOpen={Boolean(props.data)} handleClose={props.handleClose} modalClassModifier="requestModal">
      <div className="requestModal__wrap">
        <div className="requestModal__left">
          <div className="requestModal__detailsRow">
            <TextDisplay bold className="requestModal__detailsTitle">
              {props.data.l4Category?.name}
            </TextDisplay>
            <TextP3 dark>
              {city?.name && `${city.name}, `}
              {city?.regionName && city.regionName}
            </TextP3>
          </div>
          {props.data.details.map((item) => (
            <div className="requestModal__detailsRow" key={item.question_id}>
              <TextP3 className="requestModal__textGrey">{item.question}</TextP3>
              <TextP3 dark>{item.answer}</TextP3>
            </div>
          ))}
        </div>
        <div className="requestModal__right">
          <TextDisplay bold className="requestModal__textCenter">
            <Trans>Co zyskujesz dzięki Fixly?</Trans>
          </TextDisplay>
          <div className="requestModal__benefits">
            <div className="requestModal__benefit">
              <div className="requestModal__benefitIcon">
                <img src={benefits6} width="37" height="33" alt="" />
              </div>
              <div className="requestModal__benefitText">
                <TextP1 bold>
                  <Trans>Wygodna aplikacja</Trans>
                </TextP1>
                <TextP3 dark>
                  <Trans>Prosta i intuicyjna aplikacja mobilna, z którą nie przegapisz żadnego zlecenia</Trans>
                </TextP3>
              </div>
            </div>

            <div className="requestModal__benefit">
              <div className="requestModal__benefitIcon">
                <img src={benefits5} width="50" height="42" alt="" />
              </div>
              <div className="requestModal__benefitText">
                <TextP1 bold>
                  <Trans>1,2 mln zarejestrowanych klientów</Trans>
                </TextP1>
                <TextP3 dark>
                  <Trans>
                    <b>Szybki kontakt</b> z wybranymi przez Ciebie klientami
                  </Trans>
                </TextP3>
              </div>
            </div>

            <div className="requestModal__benefit">
              <div className="requestModal__benefitIcon">
                <img src={benefits8} width="35" height="33" alt="" />
              </div>
              <div className="requestModal__benefitText">
                <TextP1 bold>
                  <Trans>1,5 mln + szczegółowych zleceń</Trans>
                </TextP1>
                <TextP3 dark>
                  <Trans>Sam wybierasz szczegółowe zlecenia, dopasowane do świadczonych przez Ciebie usług</Trans>
                </TextP3>
              </div>
            </div>

            <div className="requestModal__benefit">
              <div className="requestModal__benefitIcon">
                <img src={benefits4} width="34" height="32" alt="" />
              </div>
              <div className="requestModal__benefitText">
                <TextP1 bold>
                  <Trans>Widoczność w sieci</Trans>
                </TextP1>
                <TextP3 dark>
                  {' '}
                  <Trans>Atrakcyjna strona biznesowa, dostępna również dla klientów spoza Fixly</Trans>
                </TextP3>
              </div>
            </div>
          </div>

          <Button
            as="a"
            onClick={onButtonClicked}
            href="#registration"
            type="button"
            kind="cta"
            width="full"
            className="requestModal__button"
          >
            <Trans>Wypróbuj fixly</Trans>
          </Button>

          <TextP3 dark className="requestModal__textCenter">
            <Trans>
              Klikając ten przycisk, nie wyślesz odpowiedzi na to zapytanie. Utworzysz natomiast konto, by otrzymywać
              kolejne podobne do niego.
            </Trans>
          </TextP3>
        </div>
      </div>
    </Modal>
  );
};
